import type { FaireProductEntity } from "../../entity_types/product";

export const p_7q8vhxwznk: FaireProductEntity = {
  token: "p_7q8vhxwznk",
  type: "product",
  name: "Hummingbird Floral Swedish Dishcloth",
  brandToken: "b_a7kevhkvzk",
  brandName: "Ecologie",
  imageUrl:
    "https://cdn.faire.com/fastly/39b95e3981bdd4c7d3fe6c3f4c123f3c4cf011489252efc49ff47dbf2c1a6d59.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a58740e191940acc977074f9eb0d029b303abd9294d94654ab78527100295da4.jpeg",
    "https://cdn.faire.com/fastly/6d936ee12b75bc28b2712e8f7f4632385d305ea7217996ec468255043e9ef16e.jpeg",
  ],
  priceDollars: 3.25,
  description:
    "Wipe spills from the countertop big or small. Multitasking Swedish dishcloths are compostable cellulose sponge cloths that tackle any household jobs. Plus, it's perfectly safe to use them with a full range of cleaning products and wash them over 200 times. Swedish dishcloths are versatile, super-absorbent, reusable cleaning cloths that take on the tasks of sponge, dishcloth, and paper towel. Count on it for just about everything.\n\nDimensions: W6.5 x L8in \nMaterial: 70% Cellulose, 30% Cotton\nCare Instructions: Machine wash warm, lay flat to dry.",
  tags: [],
  msrpDollars: 6.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:37.257Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
